export const SET_OBJECTS_LIST = 'SET_OBJECTS_LIST';
export const SET_NAV_PARAMS_OBJECTS = 'SET_NAV_PARAMS_OBJECTS';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const UPDATE_OBJECTS_LIST = 'UPDATE_OBJECTS_LIST';